import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { _MessageContainer } from './styles'

const hiddenFieldLabels = {
  photos: 'photos',
  prices: 'price',
  listing_info: 'details',

}

export const isAnyListingPartRemoved =
    hiddenFields => (
      hiddenFields &&
      (hiddenFields.prices ||
       hiddenFields.photos ||
       hiddenFields.listing_info)
    )


const defaultClickHandler = (e) => {
  e.preventDefault()
  e.stopPropagation()
}

export const fieldsToText = (fieldsArr) => {
  if(!fieldsArr || !fieldsArr.length) return ''
  if(fieldsArr.length <= 1) return fieldsArr.join('')
  if(fieldsArr.length <= 2) return fieldsArr.join(' and ')
  return fieldsArr.slice(0, fieldsArr.length - 1).join(', ') + ', and ' + fieldsArr[fieldsArr.length - 1]
}

const ListingRemovalMessage = (
  {
    hiddenFields,
    requireBackground,
    onContactAgentClick = defaultClickHandler,
    hideContactAgentText = false,
    showShortMessage,
    fontSize = 'md',
    pageType = 'listing',
  },
) => {
  const hasHiddenStatus = isAnyListingPartRemoved(hiddenFields)

  const { photos, prices, listing_info: listingInfo } = hiddenFields || {}
  if(!hasHiddenStatus) return null
  let child = null

  // eslint-disable-next-line react/no-unstable-nested-components
  const ContextAgentText = () => (
    <Fragment>
      Please <span onClick={onContactAgentClick}>contact an agent</span>.
    </Fragment>
  )

  if(showShortMessage) {
    child = (
      <div>
        Some content is not available. <span>See More</span>
      </div>
    )
  } else if(photos && prices && listingInfo) {
    child = (
      <div>
        This {pageType}’s photos, price, and details are not available to the public.{' '}
        { !hideContactAgentText && <ContextAgentText /> }
      </div>
    )
  } else {
    // const beVerb =
    const fields = []
    Object.keys(hiddenFields).forEach((field) => {
      if(hiddenFields[field] && hiddenFieldLabels[field]) {
        fields.push(hiddenFieldLabels[field])
      }
    })
    let beVerbs = fields.length > 1 ? 'are' : 'is'
    if(fields[fields.length - 1] !== 'price') beVerbs = 'are'
    child = (
      <div>This {pageType}’s {fieldsToText(fields)} {beVerbs} not available to the public.{' '}
        { !hideContactAgentText && <ContextAgentText /> }
      </div>
    )
  }
  return (
    <_MessageContainer
      date-test-id="listingRemovalMessage"
      requireBackground={requireBackground}
      fontSize={fontSize}
    >
      {child}
    </_MessageContainer>
  )
}

ListingRemovalMessage.propTypes = {
  hiddenFields: PropTypes.shape({
    photos: PropTypes.bool,
    listing_info: PropTypes.bool,
    prices: PropTypes.bool,
  }),
  requireBackground: PropTypes.bool,
  hideContactAgentText: PropTypes.bool,
  onContactAgentClick: PropTypes.func,
  pageType: PropTypes.string,
  fontSize: PropTypes.oneOf(['sm', 'md']),
  showShortMessage: PropTypes.bool,
}


export default ListingRemovalMessage
